import React from 'react';
import {Alert} from 'src/design/atoms/Alert';
import {Anchor} from 'src/design/atoms/Anchor';
import {Group} from 'src/design/atoms/Group';
import {Pill} from 'src/design/atoms/Pill';
import {useGetFormDefinitionQuery} from 'src/redux/queries/formDefinition';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface DemonstrationFormFailableStatusProps {
  formDefinitionId?: number;
}

/**
 * Interim discoverability fix for the "Form Is Failable" toggle, surfaced
 * inline on the demonstration content editor until Wave 6 replaces the
 * demonstration-via-Task mechanism with first-class sign-offs.
 */
export const DemonstrationFormFailableStatus: React.FC<
  DemonstrationFormFailableStatusProps
> = ({formDefinitionId}) => {
  const {data: formDefinition, isFetching} = useGetFormDefinitionQuery(
    formDefinitionId!,
    {skip: !formDefinitionId}
  );

  if (!formDefinitionId || isFetching || !formDefinition) {
    return null;
  }

  if (formDefinition.failable) {
    return (
      <Group mb="md">
        <Pill text="Failable" color="green" />
      </Group>
    );
  }

  return (
    <Alert color="yellow" title="This form cannot be failed" mb="md">
      Evaluators will be unable to record a failed demonstration with this
      form.{' '}
      <Anchor
        href={PathUtility.FormBuilderView(formDefinitionId)}
        target="_blank"
        rel="noopener noreferrer">
        Turn on &quot;Form Is Failable&quot; in Form Builder
      </Anchor>
    </Alert>
  );
};
